/**
 * @fileoverview Agent definition for the plot-extractor-v2 primitive.
 *
 * This agent reads a document and extracts a summary and writtenPlot.
 * These are prose-based narrative context fields consumed by downstream agents
 * and displayed in the UI.
 *
 * For structured storyline extraction (beats, story questions), use storyline-extraction-pipeline-v1.
 *
 * @category import.story.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'plot-extractor-v2',
  kind: 'primitive',
  name: 'Plot Extractor',
  description: 'Reads a document and extracts a summary and detailed writtenPlot outline.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-02',
    taxonomyPath: 'import.story.extraction',
    usedBy: ['ImportStoryDialog', 'use-import-story.ts'],
    relatedAgents: ['story-dna-extractor-v2', 'chapter-extractor-v2', 'storyline-extraction-pipeline-v1'],
  },
};
